module.exports = __webpack_public_path__ + "img/ice-icon.3690781c.svg";